module.exports = __webpack_public_path__ + "img/flash.4bf018b2.png";